import React from "react";
import "./Seo.css";
import ScrollToTop from "../components/ScrollToTop";
import { useNavigate } from "react-router-dom";

//import seo1 from "../assets/seo1.png";
import seoBenefitsImg from "../assets/seo1.png"; // placeholder image
import seoHero from "../assets/seo-hero.jpeg";

const SEO = () => {
  const navigate = useNavigate();

  const handleLearnMore = () => {
    navigate("/contact");
  };

  return (
    <section className="service-page seo-page">
      <ScrollToTop />

      {/* ================= HERO SECTION ================= */}
      <div className="seo-hero">
        <div className="seo-hero-inner">
          <div className="seo-hero-content">
            <h1 className="seo-hero-title">
              <span className="seo-highlight">Search Engine Optimization</span> That Improves Rankings,
              Traffic & Trust
            </h1>

            <p className="seo-hero-description">
              We help businesses grow with data driven Search Engine Optimization
              combining technical SEO, keyword strategy, content optimization, and
              performance tracking. The result is stronger visibility, better quality
              traffic, and consistent long term growth in search.
            </p>

            <button className="seo-hero-btn" onClick={handleLearnMore}>
              Get In Touch
            </button>
          </div>

          <div className="seo-hero-image">
            <img src={seoHero} alt="SEO Hero" />
          </div>
        </div>
      </div>

      <div className="service-container" id="seo-content">
        {/* ================= SEO STRATEGY ================= */}
        <section className="seo-strategy">
          <h2 className="seo-strategy-title">
            <span className="seo-strategy-kicker">Our SEO strategy in</span>
            <span className="seo-strategy-main">5 steps</span>
          </h2>

          <div className="seo-strategy-divider" />

          <div className="seo-strategy-grid">
            <div className="seo-step">
              <div className="seo-step-head">
                <div className="seo-step-circle">1</div>
                <div className="seo-step-pill">Audit</div>
              </div>
              <h3 className="seo-step-title">Understanding Your Business</h3>
              <ul className="seo-step-list">
                <li>Analyze your website performance</li>
                <li>Study competitors</li>
                <li>Identify customer search keywords on Google</li>
                <li>Define clear business goals</li>
              </ul>
            </div>

            <div className="seo-step">
              <div className="seo-step-head">
                <div className="seo-step-circle">2</div>
                <div className="seo-step-pill">On-site</div>
              </div>
              <h3 className="seo-step-title">Making Your Website Search Friendly</h3>
              <ul className="seo-step-list">
                <li>Add proper H1 & H2 headings</li>
                <li>Optimize page titles & descriptions</li>
                <li>Improve website speed & mobile experience</li>
                <li>Create clean URLs & internal links</li>
              </ul>
            </div>

            <div className="seo-step">
              <div className="seo-step-head">
                <div className="seo-step-circle">3</div>
                <div className="seo-step-pill">Content</div>
              </div>
              <h3 className="seo-step-title">Turning Visitors into Customers</h3>
              <ul className="seo-step-list">
                <li>One main keyword per page</li>
                <li>Simple service focused content</li>
                <li>FAQ sections for customer questions</li>
                <li>Natural keyword placement</li>
                <li>Pages designed for enquiries</li>
              </ul>
            </div>

            <div className="seo-step">
              <div className="seo-step-head">
                <div className="seo-step-circle">4</div>
                <div className="seo-step-pill">Off-site</div>
              </div>
              <h3 className="seo-step-title">Building Online Trust</h3>
              <ul className="seo-step-list">
                <li>Create quality backlinks</li>
                <li>Business listing submissions</li>
                <li>Improve brand visibility online</li>
                <li>Build authority & credibility</li>
              </ul>
            </div>

            <div className="seo-step">
              <div className="seo-step-head">
                <div className="seo-step-circle">5</div>
                <div className="seo-step-pill">Follow up</div>
              </div>
              <h3 className="seo-step-title">Monitor & Grow</h3>
              <ul className="seo-step-list">
                <li>Submit website to Google Search Console</li>
                <li>Track users with Google Analytics</li>
                <li>Monitor keyword performance</li>
                <li>Continuous SEO improvements</li>
              </ul>
            </div>
          </div>
        </section>

        {/* ================= BENEFITS OF SEO ================= */}
        <section className="seo-split-section">
          <div className="seo-split-grid">
            <div className="seo-split-media">
              <img src={seoBenefitsImg} alt="Benefits of SEO" />
            </div>

            <div className="seo-split-content">
              <h2 className="seo-section-title">Benefits of SEO</h2>
              <ul className="seo-bullets">
                <li>Improves search engine rankings and brand visibility</li>
                <li>Drives high quality organic traffic and leads</li>
                <li>Builds trust and credibility with customers</li>
                <li>Delivers long term growth with higher ROI (Return of Investment)</li>
              </ul>
            </div>
          </div>
        </section>

        {/* ================= WHY CHOOSE US (CARD) ================= */}
        <section className="seo-choose">
          <div className="seo-choose-card">
            <h2 className="seo-section-title">Why Choose THE WE DEV ?</h2>
            <ul className="seo-bullets">
              <li>Customized Search Engine Optimization strategies tailored to your business goals</li>
              <li>Data driven approach aligned with latest Google algorithms</li>
              <li>Transparent reporting with measurable performance insights</li>
              <li>Focus on real results leads, conversions, and growth</li>
            </ul>
          </div>
        </section>
      </div>
    </section>
  );
};

export default SEO;
